import React, {useContext, useEffect, useState} from 'react';
import UserContext from "../../common/UserContext";

//Multilingual
import {assignedKey, mainMessages, unassignedKey} from "../../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import {AssignedProductContext, GeneralContext} from "../FSARequestLicenseContext";

export const StatusCell = (props) => {
    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const localization = useLocalization();

    const assigned = props.dataItem.saved_assigned_quantity
    const unAssigned = props.dataItem.saved_selected_quantity - props.dataItem.saved_assigned_quantity

    return (
        <td>
            {unAssigned > 0 && (
                <>
                    {unAssigned} {localization.toLanguageString(unassignedKey, mainMessages[siteLanguageDefault][unassignedKey])}
                </>
            )}
            {unAssigned > 0 && assigned > 0 && <br/>}
            {assigned > 0 && (
                <>
                    {assigned} {localization.toLanguageString(assignedKey, mainMessages[siteLanguageDefault][assignedKey])}
                </>
            )}
        </td>
    );
};